// extracted by mini-css-extract-plugin
export var attribution = "_dc-4";
export var authorName = "_dc-5";
export var quote = "_dc-3";
export var testimonial = "_dc-2";
export var trustedBy = "_dc-0";
export var trustedByLabel = "_dc-1";